import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import NewConfigWizard from './pages/NewConfigWizard';
import ConfigDetailPage from './pages/ConfigDetailPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configs/new"
          element={
            <ProtectedRoute>
              <NewConfigWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/configs/:id"
          element={
            <ProtectedRoute>
              <ConfigDetailPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster position="top-center" duration={2300} />
    </div>
  );
}

export default App;
